import { TranslationBundle } from '../content-page/common/skill-learning/models/translation-bundle.model';

export class Answer {
  public answerText: string;
  public answerIndex?: number;
  public answerTextTranslation?: TranslationBundle;

  constructor(answerText: string) {
    this.answerText = answerText;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/models/answer.model.ts